import { assetInit } from 'redux/reducers/init';
import {
  requestAsset,
  requestAssetFailure,
  requestAssetSuccess,
  selectQuarter,
  setQuarterList,
} from 'redux/actions/asset/actions';

import { createReducer } from '@reduxjs/toolkit';

const asset = createReducer(assetInit, {
  [requestAsset.type]: (state, action) => {
    state.isLoading = true;
    state.isQuarterListLoading = true;
  },
  [requestAssetSuccess.type]: (state, action) => {
    const { asset, quarterList, teamList, selectedQuarter } = action.payload;
    state.isLoading = false;
    state.selectedAsset = asset;
    state.quarterList = quarterList;
    state.selectedTeam1 = teamList[0];
    state.selectedTeam2 = teamList[1];
    state.selectedQuarter = selectedQuarter;
  },
  [requestAssetFailure.type]: (state, action) => {
    state.isLoading = false;
  },
  [selectQuarter.type]: (state, action) => {
    const { quarter } = action.payload;
    state.selectedQuarter = quarter;
  },
  [setQuarterList.type]: (state, action) => {
    const { quarterList } = action.payload;
    state.quarterList = quarterList;
    state.isQuarterListLoading = false;
  }
});

export default asset;
